"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AuthGuard;
var _utils = require("@whitbread-eos/utils");
var _router = require("next/router");
var _react = require("react");
var _AuthContentManagerBBVariant = _interopRequireDefault(require("../AuthContentManager/AuthContentManagerBBVariant"));
var _jsxRuntime = require("react/jsx-runtime");
var publicRoutes = ['/404', '/graphql', '/reset-password', '/business-booker/reset-password', '/business-booker/graphql', '/business-booker/404'];
function AuthGuard(_ref) {
  var _window$location$host, _window;
  var {
    hasRegisteredSuccessfully
  } = _ref;
  var router = (0, _router.useRouter)();
  var {
    key
  } = router.query;
  var [isLoginModalOpen, setIsLoginModalOpen] = (0, _react.useState)(true);
  var {
    isLoggedIn
  } = (0, _utils.useUserData)();
  var {
    language,
    country
  } = (0, _utils.useCustomLocale)();
  var isInnBusiness = (0, _utils.isInnBusinessApp)((_window$location$host = (_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.host) !== null && _window$location$host !== void 0 ? _window$location$host : '');
  (0, _react.useEffect)(() => {
    if (isInnBusiness && !isLoggedIn && !publicRoutes.includes(router.route)) {
      window.location.href = (0, _utils.getPathForLocale)("".concat(language, "-").concat(country), 'account/login');
    }
  }, [isInnBusiness, isLoggedIn, router.route]);
  var toggleLoginModal = () => {
    setIsLoginModalOpen(!isLoginModalOpen);
  };
  if (isInnBusiness) {
    return (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
  }
  return (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: !isLoggedIn && !publicRoutes.includes(router.route) && (0, _jsxRuntime.jsx)(_AuthContentManagerBBVariant.default, {
      isLoginModalOpen: isLoginModalOpen,
      showRegisterNotification: !!key,
      hasRegisteredSuccessfully: hasRegisteredSuccessfully,
      toggleLoginModal: toggleLoginModal
    })
  });
}